<template>
  <div class="dashboard h-100">
    <app-title title="Dashboard"/>

    <div class="row">
      <div class="col-md-3 p-md-3">
        <img class="header-logo" src="/images/logo.svg" alt="Oldevuuren">
      </div>
      <div class="col-md-7 d-none d-sm-block content-middle p-md-3"></div>
      <div class="col-md-3 sidebar sidebar-right sidebar-account p-md-3">
        <template v-if="!isAuthenticated">
          <div class="row account-row float-right">
            <div @click="login" class="link">
              <font-awesome-icon class="font-awesome-icon" icon="user-circle"/>
              Inloggen
            </div>
            <div @click="register" class="link ml-4 mr-3">
              <font-awesome-icon class="font-awesome-icon" icon="plus-circle"/>
              Aanmelden
            </div>
          </div>
        </template>
        <template v-else>
          <app-account/>
        </template>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 d-none d-sm-block"></div>
      <div class="col-md-7 content-middle main p-md-3">
        <template v-if="!isAuthenticated">
          <div class="title">
            <span @click="login" class="link underline">Log in</span> of
            <span @click="register" class="link underline">meld je aan</span> als nieuwe klant
          </div>
        </template>
        <template v-else>
          <div class="row greeting-row col-md-13 mb-2">
            <div class="col-md-8 greeting">
              {{ greeting }} {{ firstName }}
            </div>
            <div class="search-order text-right col-md-5 input-group">
              <div class="input-group-prepend">
                <span class="custom-input-group-text p-1">
                  <font-awesome-icon class="font-awesome-icon" icon="search"/>
                </span>
              </div>
              <input class="form-control form-control-search" :disabled="isSearchingOrders" v-model.lazy="searchOrder" type="search" placeholder="Zoek op projectreferentie...">
            </div>
          </div>
        </template>
      </div>
      <div class="col-md-3 d-none d-sm-block sidebar sidebar-right"></div>
    </div>

    <div class="row lastrow">
      <div class="col-md-3 p-md-3 d-none d-sm-block"></div>
      <div class="col-md-7 content-middle p-md-3">
        <template v-if="!isAuthenticated">
          <!-- Register the login & register components here, they will not display anything because they're modals -->
          <app-login ref="appLogin" v-bind:registerParent="register" v-bind:forgotPasswordParent="forgotPassword"/>
          <app-register ref="appRegister" v-bind:loginParent="login" v-bind:forgotPasswordParent="forgotPassword"/>
          <app-forgot-password ref="appForgotPassword" v-bind:registerParent="register"/>

          <div class="sub-title">Als klant kun jij...</div>
          <ul class="fa-ul customer-benefits">
            <li><span class="fa-li"><font-awesome-icon class="font-awesome-icon" icon="check"/></span>Alle prijzen zien</li>
            <li><span class="fa-li"><font-awesome-icon class="font-awesome-icon" icon="check"/></span>Offertes opslaan en wijzigen</li>
            <li><span class="fa-li"><font-awesome-icon class="font-awesome-icon" icon="check"/></span>Orders bestellen</li>
          </ul>
        </template>
        <template v-else>
          <app-quotations :search="searchOrder"/>
          <app-orders :search="searchOrder"/>
        </template>
      </div>
      <div class="col-md-3 sidebar sidebar-right p-md-3">
        <template v-if="isAuthenticated">
          <app-continue-order/>
        </template>

        <app-create-quotation/>

        <app-loading-quotation/>
      </div>
    </div>
  </div>
</template>

<script>
  // General
  import CreateQuotation from '@/components/Dashboard/CreateQuotation.vue'
  import LoadingQuotation from '@/components/Dashboard/LoadingQuotation.vue'
  // Logged out
  import Login from '@/components/Auth/Login.vue'
  import Register from '@/components/Auth/Register.vue'
  import ForgotPassword from '@/components/Auth/ForgotPassword.vue'
  // Logged in
  import Account from '@/components/Account/Account.vue'
  import Orders from '@/components/Dashboard/Orders.vue'
  import Quotations from '@/components/Dashboard/Quotations.vue'
  import ContinueOrder from '@/components/Dashboard/ContinueOrder.vue'

  export default {
    name: 'dashboard',
    data() {
      return {
        'searchOrder': null
      }
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.isAuthenticated
      },
      isSearchingOrders() {
        return this.$store.getters.isSearchingOrders
      },
      firstName() {
        return !this.$store.getters.user.first_name ? '' : this.$store.getters.user.first_name
      },
      greeting() {
        const currentHour = new Date().getHours()
        if (currentHour >= 0 && currentHour < 12) {
          return 'Goedemorgen'
        } else if (currentHour >= 12 && currentHour < 18) {
          return 'Goedemiddag'
        }
        return 'Goedenavond'
      }
    },
    methods: {
      login() {
        this.$refs.appLogin.showModal()
      },
      register() {
        this.$refs.appRegister.showModal()
      },
      forgotPassword() {
        this.$refs.appForgotPassword.showModal()
      }
    },
    mounted() {
      if (localStorage.getItem('openLogin')) {
        localStorage.removeItem('openLogin')
        // Open login
        this.$refs.appLogin.showModal()
      }
    },
    components: {
      'app-login': Login,
      'app-register': Register,
      'app-forgot-password': ForgotPassword,
      'app-create-quotation': CreateQuotation,
      'app-account': Account,
      'app-orders': Orders,
      'app-quotations': Quotations,
      'app-continue-order': ContinueOrder,
      'app-loading-quotation': LoadingQuotation
    }
  }
</script>

<style lang="scss" scoped>
  .customer-benefits {
    margin-left: 25px;
  }

  .form-control-search {
    font-size: 1.2em
  }
</style>
